import './../../../css/src/main.scss';

import React from 'react';

import data from './../data/data';
import MainMenuStore from './../stores/MainMenuStore';
import EmojiIsLifeStore from './../stores/EmojiIsLifeStore';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';
import Slides from './Slides.jsx';
import MenuButton from './MenuButton.jsx';
import LandingSlide from './LandingSlide.jsx';
import Menu from './Menu.jsx';
import Share from './Share.jsx';


const EmojiIsLife = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'EmojiIsLife',


  /**
   * The iteration of the current content
   */
  contentIteration: 0,


  /**
   * Used to track how many times the user has swiped
   */
  animateIteration: 0,


  /**
   * Starting drag position of the content
   */
  startDragPos: 0,


  /**
   * Ending drag position of the content
   */
  endDragPos: 0,


  /**
   * The amount of pixels the user needs to drag to trigger a transition
   */
  dragThreshold: 10,


  /**
   * The number of slides above and below the current slide
   */
  surroundingSlideAmount: 2,


  /**
   * Timeout to reset the content positions
   */
  resetPositionTimeout: 0,


  /**
   * If the user is scrolling
   */
  scrolling: false,


  /**
   * Timeout to reset whether the user is scrolling
   */
  resetScrollTimeout: 0,


  /**
   * Expected propTypes
   * @prop {Object} data - A data object
   * @prop {Number} minDesktopWidth - The minimum width to render the desktop
   * layout
   * @prop {Boolean} touch - If browser supports touch events
   */
  propTypes: {
    data: React.PropTypes.array.isRequired,
    minDesktopWidth: React.PropTypes.number.isRequired,
    touch: React.PropTypes.bool,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      currentSlideData: [],
      menuOpen: false,
      large: false,
      currentSlide: 0,
      showLargeLanding: true,
      windowSize: {
        width: 0,
        height: 0,
      },
    };
  },


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    MainMenuStore.addChangeListener(this._onMenuChange);
    EmojiIsLifeStore.addChangeListener(this._onAppChange);
    window.addEventListener('resize', this._onResize);
    window.addEventListener('mousewheel', this._mouseWheelHandler, false);
    window.addEventListener('DOMMouseScroll', this._mouseWheelHandler, false);

    this.draggableElement = this.refs.draggable;
    this._onResize();
  },


  /**
   * Called before component is removed from the DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    MainMenuStore.removeChangeListener(this._onMenuChange);
    EmojiIsLifeStore.removeChangeListener(this._onAppChange);
    window.removeEventListener('resize', this._onResize);
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    const largeHeader = this._renderLargeHeader();
    const largeMenu = this._renderLargeMenu();
    const largeMainContentLogos = this._renderLargeMainContentLogos();
    const largeShare = this._renderLargeShare();
    const largeCredits = this._renderLargeCredits();
    const largeContentClass = this.state.viewingMainContent ?
      ' viewing-main' : '';
    const largeSectionTransitionCompleteClass =
      this.state.sectionTransitionComplete ? ' section-transition-complete' : '';
    const transitioningToLandingClass =
      (this.state.sectionTransitionComplete &&
        this.state.showLargeLanding &&
        this.state.viewingMainContent) ? ' transitioning-to-landing' : '';
    const currentSlideClass = ' slide-' + this.state.currentSlide;
    const className = 'component-emoji-is-life' +
      largeContentClass +
      currentSlideClass +
      transitioningToLandingClass +
      largeSectionTransitionCompleteClass;
    const menuIcon = this.state.menuOpen ? '🚫' : '🍔';
    const menuTouchEndHandler = this.props.touch ? this._toggleMainMenu : null;
    const menuClickHandler = !this.props.touch ? this._toggleMainMenu : null;
    const smallLogoTouchEndHandler = this.props.touch ?
      this._onSmallLogoClick : null;
    const smallLogoClickHandler = !this.props.touch ?
      this._onSmallLogoClick : null;

    return (
      <div className={className}>
        <div className='content-inner'>
          {largeHeader}
          <div className='main-content'>
            <div className='main-content-inner'>
              <div className='left-col-large'>
                {largeMainContentLogos}
                {largeMenu}
                {largeCredits}
              </div>
              <Slides
                data={data}
                large={this.state.large}
                touch={this.props.touch}
              />
            {largeShare}
            </div>
          </div>
        </div>
        <Menu
          currentSlide={this.state.currentSlide}
          data={data}
          touch={this.props.touch}
          large={this.state.large}
        />
        <div
          className='main-menu-button'
          onTouchEnd={menuTouchEndHandler}
          onClick={menuClickHandler}
        >
          {menuIcon}
        </div>
        <div className='logos'>
          <a className='br-logo' href='http://bleacherreport.com' target='_blank'>
            <img src='assets/images/br-logo-white.png' />
          </a>
          <div className='logo'
            onClick={smallLogoClickHandler}
            onTouchEnd={smallLogoTouchEndHandler}
          >
            <span>EMOJI IS LIFE</span>
          </div>
        </div>
      </div>
    );
  },


  /**
   * Mousewheel handler
   * @param {Object} e - The mousewheel event
   * @returns undefined
   */
  _mouseWheelHandler(e) {
    if (!this.scrolling && this.state.large) {
      const delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));

      this.scrolling = true;

      if (delta < 0) {
        AppDispatcher.handleViewAction({
          actionType: AppConstants.ADVANCE_SLIDE,
        });
      } else {
        AppDispatcher.handleViewAction({
          actionType: AppConstants.REVERSE_SLIDE,
        });
      }

      this.resetScrollTimeout = setTimeout(() => {
        this.scrolling = false;
      }, 1000);
    }
  },


  /**
   * Renders the large header
   * @returns {ReactElement} A ReactElement
   */
  _renderLargeHeader() {
    let largeHeader;

    if (this.state.large && this.state.showLargeLanding) {
      largeHeader = (
        <div className='large-header'>
          <LandingSlide
            active={!this.state.viewingMainContent}
            descriptionData={data[1]}
            height={window.innerHeight}
            large={this.state.large}
            windowSize={this.state.windowSize}
            touch={this.props.touch}
            yPosition={0}
          />
        </div>
      );
    }

    return largeHeader;
  },


  /**
   * Renders the large menu
   * @returns {ReactElement} A ReactElement
   */
  _renderLargeMenu() {
    const menuButtons = this._renderLargeMenuButtons();
    let largeMenu;

    if (this.state.large) {
      largeMenu = (
        <div className='large-button-wrapper'>
          <div className='sep' />
          <ul className='buttons'>
            {menuButtons}
          </ul>
        </div>
      );
    }

    return largeMenu;
  },


  /**
   * Renders the large menu buttons
   * @returns {ReactElement} A ReactElement
   */
  _renderLargeMenuButtons() {
    const buttons = [];

    for (let i = 2; i < data.length; i++) {
      const newIteration = i - 2;
      const key = 'menu-button-' + i;

      if (data[i].type !== 'credits') {
        buttons.push(
          <MenuButton
            buttonWrapperEl={this.refs.buttonWrapper}
            currentSlide={this.state.currentSlide}
            iteration={newIteration}
            data={data[i]}
            key={key}
            large={this.state.large}
            touch={this.props.touch}
          />
        );
      }
    }

    return buttons;
  },


  /**
   * Renders the logos for the main content when on a larger screen
   * @returns {ReactElement} A ReactElement
   */
  _renderLargeMainContentLogos() {
    let logos;

    if (this.state.large) {
      logos = (
        <div className='mc-logos'>
          <a className='br-logo' href='http://bleacherreport.com' target='_blank'>
            <img src='assets/images/br-logo-white.png' />
          </a>
          <div className='logo' onClick={this._onLogoClick}>
            <span>EMOJI IS LIFE</span>
          </div>
        </div>
      );
    }

    return logos;
  },


  /**
   * Renders the large share buttons
   * @returns {ReactElement} A ReactElement
   */
  _renderLargeShare() {
    let share;

    if (this.state.large) {
      share = (
        <div className='large-share'>
          <Share />
        </div>
      );
    }

    return share;
  },


  /**
   * Renders the large credits
   * @returns {ReactElement} A ReactElement
   */
  _renderLargeCredits() {
    let credits;

    if (this.state.large) {
      let creditData;

      for (let i = 0; i < data.length; i++) {
        if (data[i].type === 'credits') {
          creditData = data[i];
        }
      }

      const creditText = creditData.text.split('<br/>').join(' ');

      credits = (
        <div className='large-credits'>
          {creditText}
        </div>
      );
    }

    return credits;
  },


  /**
   * Toggles the main menu showing
   * @returns {undefined} undefined
   */
  _toggleMainMenu() {
    if (!this.state.menuOpen) {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.OPEN_MAIN_MENU,
      });
    } else {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.CLOSE_MAIN_MENU,
      });
    }
  },


  /**
   * Called when a CHANGE event is emitted from the EmojiIsLifeStore
   * @returns {undefined} undefined
   */
  _onAppChange() {
    if (this.state.large &&
      this.state.showLargeLanding &&
      !EmojiIsLifeStore.getState().showLargeLanding) {
      setTimeout(() => {
        this.setState({ currentSlide: 0 });
      }, 10);
    }

    this.setState(EmojiIsLifeStore.getState());
  },


  /**
   * Called when a CHANGE event is emitted from the MainMenuStore
   * @returns {undefined} undefined
   */
  _onMenuChange() {
    this.setState(MainMenuStore.getState());
  },


  /**
   * Click handler for the logo
   * @returns {undefined} undefined
   */
  _onLogoClick() {
    if (this.state.large) {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.SHOW_LARGE_LANDING,
      });

      setTimeout(() => {
        AppDispatcher.handleViewAction({
          actionType: AppConstants.GO_TO_LANDING_CONTENT,
        });

        AppDispatcher.handleViewAction({
          actionType: AppConstants.SECTION_TRANSITION_IN_PROGRESS,
        });
      }, 50);


      setTimeout(() => {
        AppDispatcher.handleViewAction({
          actionType: AppConstants.SLIDE_CHANGED,
          slide: 0,
        });
      }, 600);
    }
  },


  /**
   * Click handler for the logo in the small view
   * @returns {undefined} undefined
   */
  _onSmallLogoClick() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.GO_TO_SLIDE,
      slide: 0,
    });

    AppDispatcher.handleViewAction({
      actionType: AppConstants.CLOSE_MAIN_MENU,
    });
  },


  /**
   * Resize handler
   * @returns {undefined} undefined
   */
  _onResize() {
    if (window.innerWidth >= this.props.minDesktopWidth) {
      if (!this.state.large) {
        this.setState({ large: true });
      }
    } else {
      if (this.state.large) {
        this.setState({ large: false });

        AppDispatcher.handleViewAction({
          actionType: AppConstants.GO_TO_SLIDE,
          slide: 0,
        });
      }
    }

    const windowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    this.setState({ windowSize });
  },
});

export default EmojiIsLife;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/EmojiIsLife.jsx
 **/